import { render, staticRenderFns } from "./appNotification.vue?vue&type=template&id=87856af6"
import script from "./appNotification.vue?vue&type=script&lang=js"
export * from "./appNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports